export const CAPTCHA_PROVIDERS = ['yandex', 'vk', 'mock'] as const;
